import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { pushModal } from '../../Modals/redux/basicActions';
import { addMediaToTier } from '../redux/creator/actions';
import { Props } from './TierManageContentButton';
import { ModalType } from '../../Modals/redux/types';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'addMediaToTier' | 'pushLoadingModal'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (state, ownProps) => ({});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch, ownProps) => ({
  addMediaToTier: deviations => {
    dispatch(addMediaToTier({ deviations, tierDeviation: ownProps.tierDeviation }));
  },
  pushLoadingModal: () => {
    dispatch(pushModal(ModalType.LOADING_SCREEN, { wrapInModal: false }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
